import { createSlice } from "@reduxjs/toolkit";

const initialRatingViewState = { isOpen: false, rating: {} }

const ratingViewSlice = createSlice({
    name: 'rating_view',
    initialState: initialRatingViewState,
    reducers: {
        openModal(state, action) {
            state.isOpen = true
            state.rating = action.payload
        },
        closeModal(state) {
            state.isOpen = false
            state.rating = {}
        },
    }
})

export const ratingViewActions = ratingViewSlice.actions;
export default ratingViewSlice